import { ResourceType } from '../../shared/resource-type';

/**
 * The resource type for boxmetricsconfiguration
 *
 * Needs to be in a separate file to prevent circular
 * dependencies in webpack.
 */

export const METRICSCOMPONENT = new ResourceType('boxmetricsconfiguration');
